/**
 * Created by JackCui on 2021/12/21
 */

import {projectInfo} from '../../../../utils'
// 当前端
export default projectInfo
